const SnackbarMessage = ({commit, dispatch}: any, message: any, root = true) => {
    commit('Index/SET_SNACKBAR_SUCCESS', message, {root: true})
}

export default SnackbarMessage
